/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Open_Menu_AriaInputs */

const en_common_header_open_menu_aria = /** @type {(inputs: Common_Header_Open_Menu_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open navigation menu`)
};

const zh_common_header_open_menu_aria = /** @type {(inputs: Common_Header_Open_Menu_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开导航菜单`)
};

/**
* | output |
* | --- |
* | "Open navigation menu" |
*
* @param {Common_Header_Open_Menu_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_open_menu_aria = /** @type {((inputs?: Common_Header_Open_Menu_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Open_Menu_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_open_menu_aria(inputs)
	return zh_common_header_open_menu_aria(inputs)
});
export { common_header_open_menu_aria as "common.header.open_menu_aria" }